import { render, staticRenderFns } from "./ImageAndInfo.vue?vue&type=template&id=ec12d950&scoped=true&"
import script from "./ImageAndInfo.vue?vue&type=script&lang=js&"
export * from "./ImageAndInfo.vue?vue&type=script&lang=js&"
import style0 from "./ImageAndInfo.vue?vue&type=style&index=0&id=ec12d950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec12d950",
  null
  
)

export default component.exports